import { Box, Grid } from '@mui/material'
import React from 'react'

import MarketingPanel from './marketing/marketing-panel'
import Login from '../pages/public/login'
import NewPassword from '../pages/public/new-password'
import ForgotPasswordStepOne from '../pages/public/forgot-password-step-one'
import ForgotPasswordStepTwo from '../pages/public/forgot-password-step-two'
import LoginInterstitial from '../pages/public/login-interstitial'
import SmartForm from '../pages/public/smart-form'
// import NoMuni from '../pages/public/no-muni'
import {
    BrowserRouter as Router,
    Routes,
    Route,

} from "react-router-dom"

const PublicWrapper = ({ children }) => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}  >
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        {children}
                    </Box>
                </Grid>
                <Grid item xs={0} sm={6} sx={{ display: { sm: 'block', xs: 'none' } }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        <MarketingPanel />
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

const LayoutPublic = () => {
    return (
        <>
            <Router>
                <Routes>
                    <Route path="/*" element={<Login />} />
                    <Route path="/:muniName/login" element={<PublicWrapper><Login /></PublicWrapper>} />
                    <Route path="/login-interstitial" element={<PublicWrapper><LoginInterstitial /></PublicWrapper>} />
                    <Route path="/new-password" element={<PublicWrapper><NewPassword /></PublicWrapper>} />
                    <Route path="/forgot-password-step-one" element={<PublicWrapper><ForgotPasswordStepOne /></PublicWrapper>} />
                    <Route path="/forgot-password-step-two" element={<PublicWrapper><ForgotPasswordStepTwo /></PublicWrapper>} />
                    <Route path="/:muniName/smart-form/:id" element={<SmartForm />} />

                </Routes>
            </Router>
        </>
    )
}

export default LayoutPublic
